<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12379_81156)">
      <path d="M12.3977 11.3802C15.1328 11.3802 17.3501 9.12821 17.3501 6.35025C17.3501 3.57229 15.1328 1.32031 12.3977 1.32031C9.66257 1.32031 7.44531 3.57229 7.44531 6.35025C7.44531 9.12821 9.66257 11.3802 12.3977 11.3802Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12.4004 14.2539C10 14.2539 7.77297 15.0213 6.04941 16.6372C4.32585 18.2531 3.30248 20.4965 3.20312 22.8767H21.5977C21.4983 20.4965 20.475 18.2531 18.7514 16.6372C17.0278 15.0213 14.5 14.2539 12.4004 14.2539Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    <defs>
      <clipPath id="clip0_12379_81156">
      <rect width="20.8" height="24" fill="white" transform="translate(2 0.0976562)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
</script>

<style lang="scss" >
</style>